import React from "react";
import { cn } from "../../helpers/classNames";
import styles from "./styles.module.scss";

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    variant: "unstyled" | "primary" | "secondary" | "tertiary" | "snowPrimary";
    dataRole?: string;
    dataLabel?: string;
    fullWidth?: boolean;
};

export const Button: React.FC<Props> = ({
    variant,
    children,
    onClick,
    className,
    dataRole = undefined,
    fullWidth = false,
    dataLabel,
    id,
    ...rest
}) => {
    return (
        <button
            className={cn(
                styles.button,
                styles[variant],
                fullWidth && styles.fullWidth,
                className
            )}
            onClick={onClick}
            data-role={dataRole}
            data-label={dataLabel}
            id={id}
            {...rest}
        >
            {children}
        </button>
    );
};
